export const inflectLabelCount: Record<number, string> = {
	1: "první",
	2: "druhou",
	3: "třetí",
	4: "čtvrtou",
	5: "pátou",
	6: "šestou",
	7: "sedmou",
	8: "osmou",
	9: "devátou",
	10: "desátou",
};
